import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const TILES = [
  { id: "vehicles", name: "Vehicles", img: "/img/car.jpg", span: "md:col-span-4 md:row-span-2", pos: "object-[50%_60%]" },
  { id: "electronics", name: "Electronics", img: "/img/electronics.jpg", span: "md:col-span-8" },
  { id: "wearables", name: "Wearables", img: "/img/watch.jpg", span: "md:col-span-4", pos: "object-[50%_40%]" },
  { id: "laptops", name: "Laptops", img: "/img/laptop.jpg", span: "md:col-span-4" },
  { id: "home", name: "Home & furniture", img: "/img/home.jpg", span: "md:col-span-7" },
  { id: "everything", name: "Everything else", img: "/img/lifestyle.jpg", span: "md:col-span-5" },
];

const Tile = ({ t, i }) => (
  <Reveal delay={(i % 3) * 0.08} className={`${t.span} min-h-[260px]`}>
    <a href="#early-access" data-testid={`category-tile-${t.id}`}
      className="group relative block h-full min-h-[260px] overflow-hidden rounded-3xl border border-white/10 bg-[#12141C]">
      <img src={t.img} alt={t.name} loading="lazy"
        className={`absolute inset-0 h-full w-full object-cover ${t.pos || ""} grayscale-[35%] transition-[transform,filter] duration-[1200ms] ease-out group-hover:scale-105 group-hover:grayscale-0`} />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0B0E] via-[#0A0B0E]/30 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-6">
        <div>
          <p className="font-mono text-xs text-zinc-400">0{i + 1}</p>
          <h3 className="mt-1 font-display text-2xl sm:text-3xl font-bold tracking-tight">{t.name}</h3>
        </div>
        <span className="grid h-11 w-11 place-items-center rounded-full border border-white/20 bg-black/40 backdrop-blur transition-[background-color,transform] duration-500 group-hover:rotate-45 group-hover:bg-[#FF3838] group-hover:text-[#0A0B0E]">
          <ArrowUpRight className="h-5 w-5" />
        </span>
      </div>
    </a>
  </Reveal>
);

export const Categories = () => (
  <section id="categories" className="mx-auto max-w-7xl px-5 sm:px-8 pb-24 lg:pb-36" data-testid="categories-section">
    <Reveal className="mb-12 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
      <div>
        <Eyebrow>Categories</Eyebrow>
        <h2 className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">If it has to go, it goes here.</h2>
      </div>
      <p className="max-w-sm text-zinc-400">From the car you're relocating without to the sofa that won't fit the new place.</p>
    </Reveal>
    <div className="grid grid-cols-1 md:grid-cols-12 md:auto-rows-[280px] gap-4">
      {TILES.map((t, i) => <Tile key={t.id} t={t} i={i} />)}
    </div>
  </section>
);
